// Copyright (c) 2016 Deere & Company

export const gridOptions = {
    enableColResize: true,
    enableFilter: true,
    enableSorting: true,
    headerHeight: 32,
    rowHeight: 32,
    domLayout: 'autoHeight',
    suppressRowClickSelection: false,
    rowSelection: 'multiple',
    suppressMenuHide: false,
    suppressContextMenu: false,
    animateRows: true,
    enableRangeSelection: true,
    suppressMovableColumns: false,
    defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
    },
};
